export var GROSS_TYPES = {
  FRONT: 'FRONT',
  BACK: 'BACK'
};
export var PAY_TYPE_VALUES = {
  CUSTOMER_PAY: 'CUSTOMER_PAY',
  INTERNAL: 'INTERNAL'
};
var PAY_TYPE_CP = 'CP';
var PAY_TYPE_I = 'I';
export var PAY_TYPE = [{
  label: PAY_TYPE_CP,
  value: PAY_TYPE_VALUES.CUSTOMER_PAY
}, {
  label: PAY_TYPE_I,
  value: PAY_TYPE_VALUES.INTERNAL
}];
export var KEYS = {
  CODE: 'code',
  PRICE: 'price',
  COST: 'cost',
  PAY_TYPE: 'payType',
  PROFIT_TYPE: 'profitType',
  DISCLOSURE_TYPE: 'disclosureType',
  RESIDUAL_VALUE: 'residualValue',
  RESIDUALIZE: 'residualize',
  ADJUST_RESIDUAL_NOT_MSRP: 'adjustResidualNotMsrp',
  MANUALLY_RESIDUALIZED: 'manuallyResidualized',
  PRICE_WITH_TAXABLE: 'priceWithTaxable',
  TAXABLE: 'taxable'
};
export var FIELDS_TO_BE_NOT_SHOWN = [KEYS.COST, KEYS.PROFIT_TYPE];
export var FIELD_KEYS = [KEYS.CODE, KEYS.PRICE_WITH_TAXABLE, KEYS.COST, KEYS.PAY_TYPE, KEYS.RESIDUALIZE, KEYS.RESIDUAL_VALUE, KEYS.DISCLOSURE_TYPE, KEYS.PROFIT_TYPE];